import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n/lib';
import { Link } from 'react-router';
import { Button } from '../General/Button';
import { ErrorAlert } from '../Alerts/ErrorAlert';
import { Input } from '../General/Input';
import { emailIsValid } from '../../../utilities';
import { Loader } from '../General/Loader';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { InfoText, InfoType } from '../General/InfoText';
import { FormInput } from '../Form/FormInput';
import { SuccessAlert } from '../Alerts/SuccessAlert';

interface Props {
  cartId: string | undefined;
  handleFormSubmit: any;
  isFetching: boolean;
  successMessage: string;
  errorMessage: string;
}

function RegisterForm({
  handleFormSubmit,
  isFetching,
  successMessage,
  errorMessage,
}: Props) {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');

  const handleForm = e => {
    e.preventDefault();
    handleFormSubmit(email, password);
  };

  return (
    <Wrapper>
      <Header>{`${__('Vytvoriť účet')}`}</Header>
      <div>
        {errorMessage && (
          <>
            <ErrorAlert message={errorMessage} />
            <br />
            <br />
          </>
        )}
      </div>
      {successMessage && <SuccessAlert message={successMessage} />}
      <Form onSubmit={handleForm}>
        <FormInput
          type="email"
          placeholder={__('E-mail')}
          value={email}
          name="email"
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setEmail(e.target.value)}
          tabIndex={1}
          marginBottom={0}
        />
        <FormInput
          type="password"
          placeholder={__('Heslo')}
          value={password}
          name="password"
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setPassword(e.target.value)}
          tabIndex={2}
          marginBottom={0}
        />
        {/*<FormInput
          type="password"
          placeholder={__('Potvrdenie hesla')}
          value={confirmPassword}
          name="confirmPassword"
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setConfirmPassword(e.target.value)}
          tabIndex={3}
          marginBottom={0}
        />*/}
        <LoginButton
          disabled={isFetching || !emailIsValid(email) || password.length === 0}
          type="submit"
        >
          {isFetching ? (
            <FlexRowCenter>
              {`${__('Registrujem')}...`}
              <Loader className="marginLeft" small={true} />
            </FlexRowCenter>
          ) : (
            __('Registrovať sa')
          )}
        </LoginButton>
      </Form>
      <LoginWrapper>
        {`${__('Máte svoj účet')}? `}
        <Link to={__r('routes:prihlasenie', '/prihlasenie')}>
          <Login>{__('Prihláste sa')}</Login>
        </Link>
      </LoginWrapper>
    </Wrapper>
  );
}

const secondaryText = css`
  text-decoration-color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 300;
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(320)};
  background: ${({ theme }) => theme.colors.white};
  text-align: center;
`;

const Header = styled.h1`
  font-size: ${rem(30)};
  text-align: center;
  font-weight: 500;
  position: relative;
  font-family: ${({ theme }) => theme.font.secondary};
  margin-bottom: ${rem(32)};
  line-height: ${rem(39)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-transform: uppercase;

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(24)};
    line-height: ${rem(28)};
  `}
`;

const Form = styled.form`
  margin: 0;
  & input:first-of-type {
    margin-bottom: ${rem(16)};
  }

  & > div:last-of-type input {
    margin-bottom: 0;
  }
`;

const LoginButton = styled(Button)`
  width: 100%;
  max-width: ${rem(320)};
  margin: ${rem(24)} 0;

  &:disabled {
    background-color: #dcd6d6;
    color: ${({ theme }) => theme.colors.black};
  }

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.primaryOnHover};
    outline: none;
  }
`;

const Login = styled.p`
  ${secondaryText};
  display: inline-block;
  text-decoration: underline;
  margin: 0;
  margin-left: ${rem(4)};
  font-weight: 400;
`;

const LoginWrapper = styled.span`
  ${secondaryText};
  display: flex;
  justify-content: center;
`;

export { RegisterForm };
